import { render, staticRenderFns } from "./DetailServicePatching.vue?vue&type=template&id=660d69fb&"
import script from "./DetailServicePatching.vue?vue&type=script&lang=js&"
export * from "./DetailServicePatching.vue?vue&type=script&lang=js&"
import style0 from "./DetailServicePatching.vue?vue&type=style&index=0&id=660d69fb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports